module.exports = __webpack_public_path__ + "img/product-mode-solo-temporary.f28528f9.png";